import React, { useState } from 'react'
import { FormConnectOuterDiv, FieldGroup, Label, Select, Input, TextArea } from './style'

export interface ConnectModalProps {
  startupId?: string
}

export const ConnectModal = ({ startupId }: ConnectModalProps): JSX.Element => {
  const [source, setSource] = useState<string>('')
  const [responsible, setResponsible] = useState<string>('')
  const [areaInterest, setAreaInterest] = useState<string>('')
  const [description, setDescription] = useState<string>('')

  return (
    <FormConnectOuterDiv>
      <FieldGroup>
        <Label className='required'>Fonte de conexão</Label>
        <Select
          value={source}
          onChange={(e) => setSource(e.target.value)}
        >
          <option value='' disabled>Selecione</option>
          <option value='Evento'>Evento</option>
          <option value='Indicação'>Indicação</option>
          <option value='Pesquisa Online'>Pesquisa Online</option>
          <option value='Redes sociais'>Redes sociais</option>
        </Select>
        <small className='field-error-text' data-error-for='source' style={{ color: '#dc3545', textAlign: 'left' }}></small>
      </FieldGroup>

      <FieldGroup>
        <Label className='required'>Responsável pela conexão</Label>
        <Input
          type='text'
          value={responsible}
          onChange={(e) => setResponsible(e.target.value)}
          placeholder='Digite o nome do responsável pela conexão'
        />
        <small className='field-error-text' data-error-for='responsible' style={{ color: '#dc3545', textAlign: 'left' }}></small>
      </FieldGroup>

      <FieldGroup>
        <Label className='required'>Área/instituição de interesse</Label>
        <Input
          type='text'
          value={areaInterest}
          onChange={(e) => setAreaInterest(e.target.value)}
          placeholder='Prefeitura ou outras instituições públicas, empresas privadas, áreas internas da caixa'
        />
        <small className='field-error-text' data-error-for='areaInterest' style={{ color: '#dc3545', textAlign: 'left' }}></small>
      </FieldGroup>

      <FieldGroup>
        <Label>Descrição</Label>
        <TextArea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder='Digite uma descrição sobre a conexão'
          rows={4}
        />
      </FieldGroup>
    </FormConnectOuterDiv>
  )
}